<div class="hpanel gs-widget-cardmargin-bottom-5" *ngIf="viewType=='MIN'">
  <div class="panel-heading gs-widget-headerhbuilt wig-c">
    {{ headerTitle }}
  </div>
  <div class="panel-body gs-widget-bodypadding-bottom-6 padding-top-6">
    <div class="row">
      <div class="col-lg-12">
        <div class="gs-empty" *ngIf="responseData.length === 0">
          <span class="gs-empty-icon"><ng-icon name="tablerUsers"></ng-icon></span>
          <div class="gs-empty-title">No colleagues yet</div>
          <div class="gs-empty-sub">We'll suggest colleagues as you grow your network.</div>
        </div>
        <ul class="profile-list" *ngIf="responseData.length > 0">
          <ng-container *ngFor="let item of responseData | slice:0:3; let i=index">
            <app-common-profile-info [userIdInput]="item['userId']">
              <ng-container headline1> {{item.firstName}} {{item.lastName}}</ng-container>
              <ng-container headline2>{{item.organisation}}</ng-container>
              <ng-container btn>
                <button class="btn-primary btn btn-xs" (click)="connect(item)">
                  <!-- <ng-icon name="tablerPlus" aria-hidden="true"></ng-icon>  -->
                  Connect
                </button>
              </ng-container>
            </app-common-profile-info>
          </ng-container>
        </ul>
        <!-- <p style="float: right;" *ngIf="responseData.length > 3"   >
          <u><a (click)="modelopen(responseData)">...More</a></u>
        </p> -->

        <button class="gs-743-more-btn" type="button"
                *ngIf="responseData.length > 0"
                (click)="modelopen(responseData)">
          View more →
        </button>
      </div>
    </div>
  </div>
</div>

<div class="margin-bottom-5"  *ngIf="viewType=='MAX'">
  <div class="panel-body gs-widget-bodycardw" >
    <div class="row">
      <div class="col-3">
        <div class="gs-empty" *ngIf="responseData.length === 0">
          <span class="gs-empty-icon"><ng-icon name="tablerUsers"></ng-icon></span>
          <div class="gs-empty-title">No colleagues yet</div>
          <div class="gs-empty-sub">We'll suggest colleagues as you grow your network.</div>
        </div>
        <div class="col-md-3 padding-left-0 padding-right-5" *ngFor="let item of responseData">
           <app-user-card  [userDataInput]="item" [button]="'PRIMARY'" [standard]="true"></app-user-card>
        </div>
      </div>
    </div>
  </div>
</div>
